exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ev-appfooter[data-v-72a8e92e] {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  /* Set the fixed height of the footer here */\n  height: 60px;\n  line-height: 60px;\n  /* Vertically center the text there */\n  background-color: #f5f5f5;\n}\n.ev-appfooter > .container[data-v-72a8e92e] {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n", ""]);

// exports
